import { IS_PRODUCTION } from '@/utils/helpers/constants';

export const PAGE_SIZE = 12;
export const BLOG_SLUG = 'blog';
export const BLOG_LABEL = 'Blog';
export const UNCATEGORIZED_LABEL = 'Uncategorized';
export const FAVORITES_MODULE_FOR = 182;
export const TOURNAMENT_FAVORITES_MODULE_FOR = 4;
export const MEME_SUBCATEGORY_UUIDS = {
  Meme: IS_PRODUCTION
    ? '3caa0369-a619-4369-a70e-e432bd0c6f7f'
    : 'e0310c1f-4caf-494e-8ef7-cccccc7ef5d3',
  Photo: IS_PRODUCTION
    ? '6db4a893-633f-4d72-8c0d-1f87f612b80e'
    : '68eedfaf-ebb0-4ad3-a0a1-4cb7eeb8da9c',
  Video: IS_PRODUCTION
    ? 'a7d35740-c1c2-4a12-8053-23ec93066ab4'
    : '6a3167f0-6476-4030-aec7-3dfac2dd9470',
  Podcast: IS_PRODUCTION
    ? '7e63df67-95d5-4b16-a36c-a1ef0eb140dd'
    : 'ca55dc98-e594-4b52-853c-985d92de9b3f',
};
export const MEME_SUBCATEGORY_LABELS = {
  Meme: 'Memes',
  Photo: 'Photos',
  Video: 'Videos',
  Podcast: 'Podcasts',
};
export const MEME_SUBCATEGORY_SLUGS = {
  Video: 'videos',
  Photo: 'photos',
  Podcast: 'podcasts',
  Meme: 'memes',
};
export const MEME_SLUG = 'meme';
